import storeLink from "fragments/vendors/storeLink"
import gql from "graphql-tag"

const ADD_STORE_LINK = gql`
  ${storeLink}

  mutation addStoreLink($storeLinkAddInput: StoreLinkAddInput!) {
    addStoreLink(storeLinkAddInput: $storeLinkAddInput) {
      ...StoreLink
    }
  }
`
export default ADD_STORE_LINK
